module.exports = __webpack_public_path__ + "img/bugger_03.c63a3f8e.png";